// extracted by mini-css-extract-plugin
export default {"footer":"__footer_footer__79SKH"};